import {getShoppingSubscriptionResultInfo} from '@web/actions/result'
import makeSlice from '@web/slices/aitems/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(getShoppingSubscriptionResultInfo.fulfilled, (state, {payload}) => {
            const {
                subscriptionResultViewInfo: {products},
            } = payload
            state.products = products.map((product) => {
                return {
                    ecNvMid: `${product.ecNvMid ?? ''}`,
                }
            })
        })
    },
})

export default slice.reducer
